import { useEffect } from 'react';
import { useLocation, useHistory } from 'react-router';
import { useSelector } from 'react-redux';

import type { ImmutableRootState } from '@uncinc/react-drupal-core/types';

import useTypedDispatch from './useTypedDispatch';
import {
  setOpenedWithNotificationId,
  logNotificationOpened,
} from '../store/actions/Notification';

export default function useNotificationTracking(): void {
  const location = useLocation();
  const history = useHistory();
  const dispatch = useTypedDispatch();
  const isLoggedIn = useSelector<ImmutableRootState<boolean | null>, boolean | null>(
    (state) => state.getIn(['login', 'loggedIn'], null),
  );

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const rawId = params.get('notification_id');
    if (!rawId) return;

    const notificationId = parseInt(rawId, 10);

    if (!notificationId || Number.isNaN(notificationId)) return;

    dispatch(setOpenedWithNotificationId(notificationId));

    dispatch(logNotificationOpened(notificationId));

    params.delete('notification_id');
    const newSearch = params.toString();
    history.replace({ ...location, search: newSearch ? `?${newSearch}` : '' });
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.search, isLoggedIn]);
}
